module.exports = __webpack_public_path__ + "img/img11.e4ebdd96.png";